import {
  ValidationErrors,
  ValidatorFn,
  FormGroup,
  AbstractControl,
  FormControl
} from '@angular/forms';

export function idValidator(idType): ValidatorFn {
  return (control: AbstractControl) => {
    const id = control.value;
    let dig = new RegExp(/^[a-zA-Z\d-]+$/);
    if (idType !== 'taxID') {
      dig = new RegExp(/^\d+$/);
    }
    if (!dig.test(id) && id) {
      return {
        idValidator: true
      };
    }
    return null;
  };
}
